import { BigNumber } from "ethers";
import { FC, useMemo } from "react";
import { If } from "../../../components/control";
import { dashBoardNameMap } from "../../../config";
import { STAGES } from "../../../types";
import { Dashboard, findAuctionIndex } from "../../../web3/web3-hooks";
import { AuctionTime } from "./TImer";

export const RoundInfoBox: FC<{ dashboard: Dashboard; stage: number }> = ({
  dashboard,
  stage,
}) => {
  const roundName = dashBoardNameMap[stage] || "PUBLIC DUTCH AUCTION";

  const timeList = dashboard.auction_time_list.map((x) =>
    BigNumber.from(x).toNumber()
  );

  // console.log(
  //   timeList,
  //   Date.now(),
  //   timeList.map((x) => Date.now() - x * 1000)
  // );

  const minted = BigNumber.from(dashboard.totalMinted).toNumber();
  const supply = BigNumber.from(dashboard.maxSupply!!).toNumber();
  const currentMyMinted = BigNumber.from(
    dashboard.userCurrentMinted
  ).toNumber();
  const currentUserMax = BigNumber.from(
    dashboard.currentRoundUserMax
  ).toNumber();

  return (
    <div className="round-info-box">
      <div className="round-name">{roundName}</div>
      <If value={stage !== STAGES.PUBLIC_END}>
        <AuctionTime dashboard={dashboard}></AuctionTime>
      </If>
      <div className="round-supply-wrap">
        <div className="round-supply-title">SUPPLY</div>
        <div className="round-supply-box">
          {minted} / {supply}
        </div>
      </div>

      <If value={currentUserMax > 0}>
        <div className="round-progress-wrap">
          <div className="round-supply-title">MY ROUND</div>
          <div className="round-supply-box">
            {currentMyMinted} / {currentUserMax}
          </div>
        </div>
      </If>
    </div>
  );
};
